import { HtmlParser } from '@calendly/html-parser';
import { I18n } from '@calendly/i18n';
import classNames from 'classnames';
import { useCallback, forwardRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { phoneNumbersSelector, nextPrimaryPhoneNumberSelector, phoneNumberRemovalStatusSelector, phoneNumberToRemoveSelector, destroyPhoneNumber, removePhoneNumberCancel } from 'features/phone_numbers';
import { idSelector } from 'selectors/current_user';
import { ConfirmationPopup } from './confirmation_popup';
const textCss = "t14zthrc";
const Text = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'p';
  return <Component ref={ref} {...restProps} className={classNames(textCss, props.className)} />;
});
const Popup = ({
  title,
  children
}) => {
  const dispatch = useDispatch();
  const userId = useSelector(idSelector);
  const phoneNumberToRemove = useSelector(phoneNumberToRemoveSelector);
  const phoneNumberRemovalStatus = useSelector(phoneNumberRemovalStatusSelector);
  const onCloseModal = useCallback(() => {
    dispatch(removePhoneNumberCancel());
  }, [dispatch]);
  const onConfirm = useCallback(() => {
    dispatch(destroyPhoneNumber({
      userId,
      phoneNumberUuid: phoneNumberToRemove.uuid
    }));
  }, [dispatch, userId, phoneNumberToRemove]);
  return <ConfirmationPopup onClose={onCloseModal} title={title} confirmLabel={I18n.t('publisher.account_settings.phone_numbers.remove.popup.confirm')} onConfirm={onConfirm} isOpen isLoading={phoneNumberRemovalStatus === 'requesting'}>
      {children}
    </ConfirmationPopup>;
};
const RemoveLastPhoneNumberPopup = () => <Popup title={I18n.t('publisher.account_settings.phone_numbers.remove.popup.title')}>
    <Text>
      {I18n.t('publisher.account_settings.phone_numbers.remove.popup.remove_last_text')}
    </Text>
  </Popup>;
const RemovePrimaryPhoneNumberPopup = () => {
  const {
    e164_phone_number: phoneNumber
  } = useSelector(nextPrimaryPhoneNumberSelector);
  return <Popup title={I18n.t('publisher.account_settings.phone_numbers.remove.popup.remove_primary_title')}>
      <Text>
        {HtmlParser(I18n.t('publisher.account_settings.phone_numbers.remove.popup.remove_primary_text', {
        phone_number: phoneNumber
      }))}
      </Text>
      <Text>
        {I18n.t('publisher.account_settings.phone_numbers.remove.popup.remove_primary_text2')}
      </Text>
    </Popup>;
};
const RemovePhoneNumberPopup = () => <Popup title={I18n.t('publisher.account_settings.phone_numbers.remove.popup.title')}>
    <Text>
      {I18n.t('publisher.account_settings.phone_numbers.remove.popup.text')}
    </Text>
  </Popup>;
export const RemovePopup = () => {
  const phoneNumberRemovalStatus = useSelector(phoneNumberRemovalStatusSelector);
  const phoneNumbers = useSelector(phoneNumbersSelector);
  const {
    primary
  } = useSelector(phoneNumberToRemoveSelector);
  const lastPhoneNumber = phoneNumbers.length === 1;
  const isPopupOpen = phoneNumberRemovalStatus !== 'ready';
  if (!isPopupOpen) return null;
  if (lastPhoneNumber) {
    return <RemoveLastPhoneNumberPopup />;
  }
  if (primary) {
    return <RemovePrimaryPhoneNumberPopup />;
  }
  return <RemovePhoneNumberPopup />;
};

require("./remove_popup.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./remove_popup.js");